import React from "react";
import { Container, Navbar } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import SkeltonLogo from "./../../assets/skelton-img/LogoSkelton.png";
import "./skelton.css";

const PrivacySkelton = () => {
  return (
    <>
      <Navbar collapseOnSelect expand="lg" className=" navbar"style={{ paddingLeft: "16px", paddingRight: "16px", overflow: "hidden" }}>
        <Container className=" w-100 px-0 d-flex ">
          <div className=" d-flex justify-start align-items-center gap-4">
            <Skeleton
              width={48}
              height={48}
              className="custom-skeleton"
              circle
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.70)",
              }}
            />
            <Skeleton
              width={164}
              height={21}
              className="custom-skeleton skelton-width-ctrl-two"
              style={{
                borderRadius: "40px",
                backgroundColor: "rgba(255, 255, 255, 0.20)",
              }}
            />
          </div>
          <div className=" d-flex justify-end align-items-center ">
            <img src={SkeltonLogo} alt="" />
          </div>
        </Container>
      </Navbar>
      <div className="skeleton-privacy " style={{ paddingLeft: "16px", paddingRight: "16px", overflow: "hidden" }}>
        <div className="w-100 ">
          <Skeleton
            width={682}
            height={35}
            className="custom-skeleton skelton-width-ctrl-one"
            style={{
              borderRadius: "50px",
              backgroundColor: "rgba(255, 255, 255, 0.20)",
            }}
          />
          <Skeleton
            width={"372px"}
            height={16}
            className="custom-skeleton skelton-width-ctrl-two"
            style={{
              marginTop: "38px",
              borderRadius: "50px",
              backgroundColor: "rgba(255, 255, 255, 0.20)",
            }}
          />
          <Skeleton
            width={"193px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-two"
            style={{
              marginTop: "40px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
          <Skeleton
            width={"428px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-one"
            style={{
              marginTop: "6px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
          <Skeleton
            width={"603px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-two"
            style={{
              marginTop: "6px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
        </div>

        <div className="w-100">
          <Skeleton
            width={220}
            height={21}
            className="custom-skeleton skelton-width-ctrl-two"
            style={{
              borderRadius: "50px",
              backgroundColor: "rgba(255, 255, 255, 0.20)",
            }}
          />

          <Skeleton
            // width={"193px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-two"
            style={{
              marginTop: "24px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
          <Skeleton
            width={"665px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-one"
            style={{
              marginTop: "6px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
          <Skeleton
            width={"428px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-two"
            style={{
              marginTop: "6px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
          <Skeleton
            width={"425px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-two"
            style={{
              marginTop: "6px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
        </div>

        <div className="w-100">
          <Skeleton
            width={354}
            height={21}
            className="custom-skeleton skelton-width-ctrl-one"
            style={{
              borderRadius: "50px",
              backgroundColor: "rgba(255, 255, 255, 0.20)",
            }}
          />

          <Skeleton
            width={"535px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-one"
            style={{
              marginTop: "24px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
          <Skeleton
            width={"698px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-two"
            style={{
              marginTop: "6px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
          <Skeleton
            width={"625px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-two"
            style={{
              marginTop: "6px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
        </div>

        <div className="w-100">
          <Skeleton
            width={488}
            height={21}
            className="custom-skeleton skelton-width-ctrl-two"
            style={{
              borderRadius: "50px",
              backgroundColor: "rgba(255, 255, 255, 0.20)",
            }}
          />

          <Skeleton
            width={"478px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-one"
            style={{
              marginTop: "24px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
          <Skeleton
            width={"746px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-one"
            style={{
              marginTop: "6px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
          <Skeleton
            width={"491px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-two"
            style={{
              marginTop: "6px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
        </div>

        <div className="w-100">
          <Skeleton
            width={258}
            height={21}
            className="custom-skeleton skelton-width-ctrl-one"
            style={{
              borderRadius: "50px",
              backgroundColor: "rgba(255, 255, 255, 0.20)",
            }}
          />

          <Skeleton
            width={"578px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-one"
            style={{
              marginTop: "24px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
          <Skeleton
            width={"746px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-two"
            style={{
              marginTop: "6px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
          <Skeleton
            width={"391px"}
            height={14}
            className="custom-skeleton skelton-width-ctrl-two"
            style={{
              marginTop: "6px",
              borderRadius: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.10)",
            }}
          />
        </div>
      </div>
    </>
  );
};

export default PrivacySkelton;
